var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerPin02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.4167C11.3814 10.4167 12.5007 9.29746 12.5007 7.91675C12.5007 6.53604 11.3814 5.41675 10.0007 5.41675C8.61994 5.41675 7.50065 6.53604 7.50065 7.91675C7.50065 9.29746 8.61994 10.4167 10.0007 10.4167Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.3334C11.6673 15.0001 16.6673 12.8486 16.6673 8.33342C16.6673 4.65152 13.6825 1.66675 10.0007 1.66675C6.31875 1.66675 3.33398 4.65152 3.33398 8.33342C3.33398 12.8486 8.33398 15.0001 10.0007 18.3334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin02);
export default __webpack_public_path__ + "static/media/marker-pin-02.ab86d08c6aa0dcf593c6a931b969eda7.svg";
export { ForwardRef as ReactComponent };